module.exports = "<pre><code #codeEditor [class.invalid]=\"!isJsonValid\" spellcheck=\"false\" contenteditable=\"true\" class=\"highlight {{language}}\" highlight-js-content=\".highlight\"></code></pre>\r\n<div *ngIf=\"!isJsonValid\" class=\"alert alert-danger\">\r\n    {{'components.common.json-editor.invalid-json' | translate}}\r\n    <br/>\r\n    <span>{{error}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/jsonEditor/jsonEditor.component.html
// module id = ./src/app/components/common/jsonEditor/jsonEditor.component.html
// module chunks = main